module.exports = __webpack_public_path__ + "static/media/HCMM332.4c6301a7.jpg";